import { AbstractControl } from '@angular/forms';
import { calculateAge, dobRegex } from './util';

export default function missingCharacter(char: string) {
  return (control: AbstractControl) => {
    if (control && control.value) {
      const value = control.value as string;
      if (value.indexOf(char) <= -1) {
        return {
          missingCharacter: true,
        };
      }
    }
    return null;
  };
}
